import styled from "styled-components";

export const Head = styled.header`
  width: 590px;
  height: 90px;
  margin: 20px 0;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--fair-pink);
  font-size: 1.5rem;
  box-shadow: 2px 0px 14px 4px var(--fair-pink);

  h1 {
    padding-left: 20px;
  }

  @media screen and (max-width: 770px) {
    font-size: 1.2rem;
    width: 480px;
    height: 80px;
    margin: 20px 0 30px 0;
  }

  @media screen and (max-width: 580px) {
    font-size: 1rem;
    width: 418px;
  }

  @media screen and (max-width: 500px) {
    width: 344px;
    height: 50px;
    margin: 45px 0;
    font-size: 0.8rem;
    -webkit-transform: scale(1, 1.8);
  }

  @media screen and (max-width: 410px) {
    width: 280px;
    height: 40px;
    margin: 40px 0 50px 0px;
    font-size: 0.6rem;
    -webkit-transform: scale(1, 2.4);
  }

  svg {
    font-size: 4rem;
    color: var(--amber);

    @media screen and (max-width: 770px) {
      font-size: 3.5rem;
    }

    @media screen and (max-width: 500px) {
      font-size: 2.5rem;
    }

    @media screen and (max-width: 410px) {
      font-size: 2rem;
    }
  }

  a {
    width: max-content;
    height: 30px;
    line-height: 30px;
    padding: 0px 8px;
    border-radius: 20%;
    text-align: center;
    background-color: var(--snow-flurry);

    position: relative;
    top: 45px;
    right: 7px;

    @media screen and (max-width: 770px) {
      top: 42px;
      right: 10px;
    }

    @media screen and (max-width: 580px) {
      height: 24px;
      line-height: 24px;
      right: 8px;
      top: 40px;
    }

    @media screen and (max-width: 500px) {
      font-size: 0.5rem;
      height: 18px;
      line-height: 18px;
      padding: 0 4px;
      right: 3px;
      top: 25px;
    }

    @media screen and (max-width: 410px) {
      font-size: 0.4rem;
      width: max-content;
      height: 16px;
      line-height: 16px;
      padding: 0px 3px;
      top: 20px;
    }

    svg {
      font-size: 1.5rem;
      color: var(--black-pearl);

      @media screen and (max-width: 920px) {
      }

      @media screen and (max-width: 580px) {
        width: 20px;
        font-size: 1.1rem;
        height: 22px;
        line-height: 22px;
      }

      @media screen and (max-width: 500px) {
        font-size: 0.5rem;
        height: 18px;
        line-height: 18px;
        padding: 0;
      }

      @media screen and (max-width: 410px) {
        font-size: 0.2rem;
        height: 16px;
        line-height: 16px;
      }
    }
  }
`;

export const Container = styled.div`
  width: 98vw;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;  
  }

  .main {
    width: 290px;
    margin: 23px 12px;
    border: 1px solid var(--ghost-white);
    border-radius: 6px;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    background-color: var(--fair-pink);

    @media screen and (max-width: 410px) {
      width: 250px;
    }

    .drinkName {
      width: 90%;
      text-decoration: underline var(--seal-brown);
      font-weight: 700;
      text-align: center;
      letter-spacing: 0.2rem;
      color: var(--seal-brown);
    }

    .first-brewed {
      width: 90%;
      text-align: right;
      color: var(--autumn-fern);
      font-weight: 700;
      border-right: 1px solid var(--autumn-fern);
    }

    .viewMore {
      width: 90%;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      background-color: var(--matterhorn);
      color: var(--snow-flurry);

      span {
        display: flex;
        justify-content: flex-start;
        align-items: center;


        svg {
          width: 2.5rem;
          height: 2rem;
          cursor: pointer;
        }
      }
    }

    .description {
      width: 90%;
      margin: 0;
      padding: 10px;
      border: none;
      white-space: wrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--ghost-white);
      background-color: var(--matterhorn);
    }

    img {
      width: 100px;
      height: 200px;
      padding: 10px;
    }

    .volume {
      width: 90%;
      color: var(--black-pearl);
      font-weight: 700;
      border-left: 1px solid var(--black-pearl);
    }
`;

export const Foot = styled.footer`
  width: 100%;
  padding: 0 0 30px 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  button {
    max-width: 200px;
  }

  a {
    height: 30px;
    width: 60px;
    border-radius: 20%;
    font-size: 1.5rem;
    text-align: center;
    line-height: 37px;
    background-color: var(--seal-brown);
    color: var(--snow-flurry);
  }
`;
